module.exports = __webpack_public_path__ + "static/media/overdueA.1ec89329.svg";